import React, {Component} from 'react';
import {Input, Button, Form, Dropdown} from 'semantic-ui-react';
import Single from '../Single'
import firebase from 'firebase/compat/app'
import 'firebase/compat/database';
import Styles from './nuevoPendiente.module.css'
import FormStyles from '../forms/form.module.css'
import DateUtilities from '../DateUtilities'

class NuevoPendiente extends Component{

	constructor(props){
		super(props);
		this.state = {
			nuevoPendiente:{
				fechaInicio: '',
				fechaFin: '',
				actividad: '',
				descripcion: '',
				lugarPendiente: '',
				lugarCompletado:'',
				zona: '',
				tunel: '',
			},
			fechaInicioStr:'',
			fechaFinStr:'',
            zonaId:'',
            mensajes:{
                actividad:false,
                superficie:false,
            },
		};
		this.handleUserInput = this.handleUserInput.bind(this);
		this.writeNew = this.writeNew.bind(this);
		this.changeModal= this.props.changeModal;
	}

	handleUserInput(e, {value, name, options}){
		const nuevoPendiente=this.state.nuevoPendiente
		if(name==='fechaInicio' || name==='fechaFin'){
			const fecha=DateUtilities.parseDate(value)
			nuevoPendiente[name]=fecha
			this.setState({
				nuevoPendiente:nuevoPendiente,
				[`${name}Str`]:value
			})
			return null
        }
        nuevoPendiente[name]=value
        if(name==='tunel'){
            nuevoPendiente.lugarPendiente=''
            for(let i =0; i<nuevoPendiente.tunel.length; i++){
                nuevoPendiente.lugarPendiente+=this.state.nuevoPendiente.zona + '/' + this.state.nuevoPendiente.tunel[i]
                if(i<nuevoPendiente.tunel.length-1)
                    nuevoPendiente.lugarPendiente+=','
            }
			this.setState({nuevoPendiente:nuevoPendiente})
			return null
        }
		if(name==='zona'){
            nuevoPendiente.tunel=[]
            nuevoPendiente.lugarPendiente=this.state.nuevoPendiente.zona.toString()
			const {key}= options.find(o=>o.value===value)
			this.setState({zonaId:key, nuevoPendiente:nuevoPendiente})
			return null
		}
		this.setState({nuevoPendiente:nuevoPendiente})
	}
    validateSubmit=()=>{
        const state=this.state
        let pasa=true
        if(state.nuevoPendiente.actividad===''){
            pasa=false
            state.mensajes.actividad=true
        }
        else{
            state.mensajes.actividad=false
        }
        if(state.nuevoPendiente.lugarPendiente===''){
            pasa=false
            state.mensajes.superficie=true
        }
        else{
            state.mensajes.superficie=false
        }
        if(!pasa){
            this.setState(state)
        }
        return pasa
    }
	writeNew(e){
        e.preventDefault()
        if(!this.validateSubmit()) return null
		const data = this.state.nuevoPendiente;
		this.props.addAct(data);
		this.setState({
			nuevoPendiente:{
				fechaInicio: '',
				fechaFin: '',
				actividad: '',
				descripcion: '',
				lugarPendiente: '',
				lugarCompletado:'',
				zona: '',
				tunel: '',
			},
			fechaInicioStr:'',
			fechaFinStr:'',
            zonaId:'',
            mensajes:{
                actividad:false,
                superficie:false,
            },
		});
		this.changeModal(false);
	}

	render(){
		return(
			<div>
				<form className={FormStyles.form} onSubmit={this.writeNew}>
					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Actividad</label>
						<div className={FormStyles.fieldContent}>
							<div>
								<Single placeholder='Selecciona una actividad' tabla='Actividades' columna='nombre' onChange={this.handleUserInput} required={true} name='actividad' value={this.state.nuevoPendiente.actividad}/>
							</div>
							{
								this.state.mensajes.actividad
								? <p className={FormStyles.error}>Campo requerido</p>
								: null
							}
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Descripción</label>
						<div className={FormStyles.fieldContent}>
							<Input fluid type='text' placeholder='Describe brevemente la tarea' name='descripcion' onChange={this.handleUserInput} value={this.state.nuevoPendiente.descripcion}/>
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Fechas</label>
						<div className={`${FormStyles.fieldContent} ${Styles.dateGrid}`}>
							<div>
								<label className={FormStyles.subLabel}>Inicio</label>
								<Input fluid type='date' name='fechaInicio' required={true} onChange={this.handleUserInput} value={this.state.fechaInicioStr} />
							</div>
							<div>
								<label className={FormStyles.subLabel}>Fecha límite</label>
								<Input fluid type='date' name='fechaFin' required={true} onChange={this.handleUserInput} value={this.state.fechaFinStr} />
							</div>
						</div>
					</Form.Field>

					<Form.Field className={FormStyles.fieldRow}>
						<label className={FormStyles.fieldLabel}>Superficie</label>
						<div className={FormStyles.fieldContent}>
							<div className={Styles.surfaceGrid}>
								<div>
									<label className={FormStyles.subLabel}>Zona</label>
									<ZonaDropDown placeholder='Selecciona una zona' tabla='Zonas' columna='sector' onChange={this.handleUserInput} required={true} name='zona' value={this.state.nuevoPendiente.zona}/>
								</div>
								{
									this.state.zonaId!=='' ? 
									<div>
										<label className={FormStyles.subLabel}>Túneles</label>
										<TunelesDropDown 
											placeholder='Selecciona túneles' 
											key={this.state.zonaId} 
											tabla='Zonas' 
											columna='tuneles'
											value={this.state.nuevoPendiente.tunel} 
											doc={this.state.zonaId} onChange={this.handleUserInput}  
											name='tunel'
										/>
									</div>
									:null
								}
							</div>
							{
								this.state.mensajes.superficie
								? <p className={FormStyles.error}>Campo requerido</p>
								: null
							}
						</div>
					</Form.Field>

					<div className={FormStyles.actions}>
						<Button type='button' basic onClick={() => this.changeModal(false)}>Cancelar</Button>
						<Button type='submit' positive>Agregar</Button>
					</div>
				</form>
			</div>
		)
	}
}

class TunelesDropDown extends React.Component{
	constructor(props){
		super(props)
		this.state={
			options:[]
		}
		this.database=firebase.firestore().collection(this.props.tabla).doc(this.props.doc)
	}
	componentDidMount(){
		this.database.get().then(doc=>{
			if(!doc.exists){
                console.log('El campo no existe')
                return null
            }
            const fieldArray=doc.data()[this.props.columna]
            if (!Array.isArray(fieldArray)){
				console.log('El campo recibido no es un array')
				return null
			}
           for(let i=0; i<fieldArray.length; i++){
			   const options=this.state.options
			   options.push({key:i, value:i+1, text:i+1})
			   this.setState({options:options})
		   }
		})
	}
	render(){
		return (
		<div className='SelectContainer'>
			<Dropdown
				labeled
				fluid
				multiple
				selection
				options={this.state.options}
				{...this.props}
			/>
		</div>
		)
	}
}

class ZonaDropDown extends React.Component{
	//Dropdown Creado por las necesidades especiales de zona
	constructor(props){
		super(props);

		this.app= firebase;
		this.database = this.app.firestore().collection(this.props.tabla).orderBy(this.props.columna, 'asc');

		this.state = {
			options: [],
		}
	}
	childAdded=(querySnapshot)=>{
        const docs = []
        let count=0
        querySnapshot.forEach(doc=>{
            docs.push({key:doc.id, value:doc.data()[this.props.columna], text:`sector: ${doc.data()[this.props.columna]} - ${doc.data().variedad}`})
            count++
            if(count===querySnapshot.size){
                this.setState({
                    options:docs
                })
            }
        })
		
	}
	componentDidMount(){
		this.database.onSnapshot(this.childAdded)
	}
	render(){
		return (
		<div className='SelectContainer'>
			<Form.Dropdown 
				fluid
				selection
				options={this.state.options}
				{...this.props}
			/>
		</div>
		)
	}
}

export default NuevoPendiente;
